import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Cards from '../Cards';
import Carousel from '../Carousel';
import Footer from '../Footer';

function Home() {
  return (
    <React.Fragment>
      <HeroSection />
      <Cards />
      <div id="carousel-section"><Carousel /></div>
      <Footer />
    </React.Fragment>
  );
}

export default Home;
